import { useDebouncedValue } from "@mantine/hooks";
import type { FC } from "react";

import { useClientManager } from "@megaron/react-clients";

import { SupportTicketInvoiceTile } from "./SupportTicketInvoiceTile";

type Props = {
  invoiceNumber: string;
};

export const SupportTicketLinkedInvoice: FC<Props> = ({ invoiceNumber }) => {
  const trimmedInvoiceNumber = invoiceNumber.trim();
  const [debouncedInvoiceNumber] = useDebouncedValue(trimmedInvoiceNumber, 300);
  const docs = useClientManager("docs");
  const invoiceThreadsQuery = docs.searchInvoiceThreads().useQuery(
    { invoiceNumber: debouncedInvoiceNumber, limit: 2 },
    { enabled: debouncedInvoiceNumber.length > 0 },
  );
  const exactMatches = (invoiceThreadsQuery.data?.items ?? []).filter(
    (thread) => thread.invoice.invoiceNumber === debouncedInvoiceNumber,
  );

  if (exactMatches.length !== 1) {
    return null;
  }

  const thread = exactMatches[0];

  return (
    <SupportTicketInvoiceTile
      threadUuid={thread.threadUuid}
      title={thread.title}
      invoiceIssuer={thread.invoice.issuer}
      invoiceNumber={thread.invoice.invoiceNumber}
    />
  );
};
